import { useState } from 'react'
import Swal from 'sweetalert2'
import { getAllArticulos, saveArticulosImportar } from '../../../Services/articuloService'
import { articulosExcel } from '../../../Services/reporteService'
import showImportResult, { showImportError } from '../../../utils/showImportResult'

//Este hook contendrá lógica y funciones generales para manejar artículos
const useArticle = () => {

  const handleImprimir = async () => {
    try {
      const articulos = await getAllArticulos(true, 0, '', 50000)
      const excel = await articulosExcel(articulos.data.content, null)

      const byteCharacters = atob(excel.data)

      const byteNumbers = new Array(byteCharacters.length)

      for (let i = 0; i < byteCharacters.length; i++) {
        byteNumbers[i] = byteCharacters.charCodeAt(i)
      }
      const byteArray = new Uint8Array(byteNumbers)
      const blob = new Blob([byteArray], {
        type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
      })

      const url = window.URL.createObjectURL(blob)
      const link = document.createElement('a')
      link.href = url
      link.download = 'articulos.xlsx'
      document.body.appendChild(link)
      link.click()
      document.body.removeChild(link)
      window.URL.revokeObjectURL(url)
    } catch (error) {
      Swal.fire({
        icon: 'error',
        title: 'Error',
        text: 'Hubo un problema al generar el archivo.',
        showConfirmButton: true,
      })
    }
  }

  const [file, setFile] = useState()
  const [isLoading, setIsLoading] = useState(false)

  const addArticuloSubmit = (e) => {
    e.preventDefault()
    setIsLoading(true)
    const formData = new FormData()
    formData.append('file', file)

    saveArticulosImportar(formData)
      .then((data) => {
        showImportResult(data, 'artículos')
      })
      .catch(() => {
        showImportError('artículos')
      })
      .finally(() => setIsLoading(false))
  }

  return {
    handleImprimir, 
    isLoading,
    setFile,
    addArticuloSubmit,
    file
  }
}

export default useArticle